import * as React from 'react';

import {RelativeTimestamp} from 'shells/timestamp/relative-timestamp';

import type {LandingPageFullFragment} from 'nutshell-graphql-types';

export const getBadgeInfo = (status?: string | null) => {
    switch (status) {
        case 'NEW':
            return {
                text: 'New',
                level: 'info',
            };
        case 'PUBLISHED':
            return {
                text: 'Published',
                level: 'success',
            };
        case 'UNDER_REVIEW':
            return {
                text: 'Under review',
                level: 'warning',
            };
    }
};

// Unused for now, will be in the status bar once we have page views working
export const getPageViews = (pageViews: number) => {
    return (
        <span className='flex'>
            {pageViews} page view{pageViews === 1 ? '' : 's'}
        </span>
    );
};

export const getUpdatedTimestamp = (updatedTime: number) => {
    return (
        <span className='flex'>
            Last updated&nbsp;
            <RelativeTimestamp datetime={updatedTime} format='fromNow' />
        </span>
    );
};

export const getViewPageLink = (page: LandingPageFullFragment) => {
    if (page.subdomainRecord) {
        return `${page.subdomainRecord.formattedRecord}${page.urlSlug}`;
    } else {
        return page.nutshellPublishedUrl;
    }
};
